export { default } from "./withAccountSettingsPrivileges";
